import { render, staticRenderFns } from "./autoAssign.vue?vue&type=template&id=83406410&scoped=true&"
import script from "./autoAssign.vue?vue&type=script&lang=js&"
export * from "./autoAssign.vue?vue&type=script&lang=js&"
import style0 from "./autoAssign.vue?vue&type=style&index=0&id=83406410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83406410",
  null
  
)

export default component.exports